module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "paymentView"
    }
  }, [(!_vm.isLoading) ? _c('mu-stepper', {
    attrs: {
      "activeStep": 1
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n          " + _vm._s(_vm.$t('message.labelProceed')) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "paymentModal loading"
  }, [_c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "paymentModal",
    class: {
      'processedOrCancelled': _vm.isPaymentCancelled || _vm.hasPaymentProcessed
    }
  }, [_c('mu-row', [(_vm.isPaymentCancelled) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "block cancelled"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailed')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallPaywallFailedExplain')))]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "label": "Try again"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('Payment')
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasPaymentProcessed) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [(_vm.hasPaymentProcessed) ? _c('div', {
    staticClass: "block success"
  }, [_c('div', {
    attrs: {
      "id": "invoice"
    }
  }, [_c('h1', [_vm._v("Payment Receipt")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "paymentDetails"
    }
  }, [(_vm.getParam('st') === 'Completed') ? _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallStatusComplete')))]) : _vm._e(), _vm._v(" "), (_vm.getParam('st') === 'Pending') ? _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallStatusPending')))]) : _vm._e(), _vm._v(" "), (_vm.getParam('st') === 'Failed') ? _c('p', [_vm._v(_vm._s(_vm.$t('message.paywallStatusFailed')))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Description")]), _vm._v(" "), _c('td', {
    domProps: {
      "textContent": _vm._s(_vm.getParam('item_name'))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("TXNID")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm.getParam('tx')) + "\n                      "), _c('span', {
    staticClass: "keepsafe"
  }, [_vm._v("Keep safe")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', {
    domProps: {
      "textContent": _vm._s(_vm.getParam('st'))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Price")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getParam('amt')) + _vm._s(_vm.getParam('cc')))])])])])]), _vm._v(" "), (_vm.getParam('st') === 'Completed') ? _c('mu-flat-button', {
    staticClass: "button getStartedBtn",
    attrs: {
      "icon": "verified_user",
      "type": "button",
      "label": "Get started"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToGetStarted.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button printBtn",
    attrs: {
      "icon": "print",
      "type": "button",
      "label": "Print a copy"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.printInvoice.apply(null, arguments)
      }
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isPaymentCancelled && !_vm.hasPaymentProcessed) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "60",
      "desktop": "60"
    }
  }, [_c('div', {
    staticClass: "block payment"
  }, [_c('h1', [_vm._v("Personalise your program")]), _vm._v(" "), _c('p', [_vm._v("Get access and support for " + _vm._s(_vm.paypal.currency_sym + _vm.paypal.amount) + ". "), _c('br'), _vm._v(" Join over " + _vm._s(_vm.numeral(_vm.stats.count).format('0,0')) + " people today")]), _vm._v(" "), _c('paypal-form', {
    attrs: {
      "paypal": _vm.paypal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, [_c('img', {
    attrs: {
      "src": "https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppppcmcvdam.png",
      "alt": "Pay with PayPal, PayPal Credit or any major credit card"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "seperator"
  }, [_c('div', {
    staticClass: "overlay"
  }, [_c('span', [_vm._v("Or")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "voucherForm",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "voucher"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "tablet": "65",
      "desktop": "65",
      "width": "65"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "id": "voucherTxt",
      "hintText": "Voucher code",
      "fullWidth": "",
      "min": 20
    },
    model: {
      value: (_vm.voucher.code),
      callback: function($$v) {
        _vm.$set(_vm.voucher, "code", $$v)
      },
      expression: "voucher.code"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "30",
      "desktop": "30",
      "width": "30"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "apply",
    attrs: {
      "id": "submitBtn",
      "type": "button",
      "label": "Redeem",
      "disabled": (_vm.voucher.code.length <= 3) || _vm.voucher.isSending,
      "color": "#FFF",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processVoucher.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "message",
    class: {
      error: _vm.voucher.error === true,
      success: _vm.voucher.error === false
    },
    domProps: {
      "textContent": _vm._s(_vm.voucher.isSending ? 'Processing...' : _vm.voucher.message)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("After paying, you will be asked to customise your program. You will receive:")]), _vm._v(" "), _c('div', {
    staticClass: "benefits"
  }, [_c('ul', [_c('li', [_vm._v("Award-winning structured education on therapeutic nutrition")]), _vm._v(" "), _c('li', [_vm._v("Practical Action Points to achieve your health goal")]), _vm._v(" "), _c('li', [_vm._v("Daily meal plans for 12 weeks to kick start your journey")]), _vm._v(" "), _c('li', [_vm._v("Tailored messages from your mentor to keep you on track")]), _vm._v(" "), _c('li', [_vm._v("Support from behavioural health mentors")]), _vm._v(" "), _c('li', [_vm._v("Peer support 24/7 from " + _vm._s(_vm.numeral(_vm.stats.count).format('0,0')) + " members")]), _vm._v(" "), _c('li', [_vm._v("Integrated food diary with food search and barcode scanner")]), _vm._v(" "), _c('li', [_vm._v("Integrated health tracking and data exporting")]), _vm._v(" "), _c('li', [_vm._v("Searchable library of recipes tailored to your preferences")]), _vm._v(" "), _c('li', [_vm._v("Daily updated news, research and expert opinions")]), _vm._v(" "), _c('li', [_vm._v("Library of resources")]), _vm._v(" "), _c('li', [_vm._v("Access on any device on web, iOS and Android")]), _vm._v(" "), _c('li', [_vm._v("Connect to Apple Health and sync your data")]), _vm._v(" "), _c('li', [_vm._v("Receive constantly updated features and enhancements")]), _vm._v(" "), _c('li', [_vm._v("Sync with FitBit")]), _vm._v(" "), _c('li', [_vm._v("Access on your Apple Watch")]), _vm._v(" "), _c('li', [_vm._v("Friendly technical support")])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.hasPaymentProcessed && !_vm.isPaymentCancelled) ? _c('mu-col', {
    staticClass: "panel",
    attrs: {
      "width": "100",
      "tablet": "40",
      "desktop": "40"
    }
  }, [_c('h2', [_vm._v("Free health tracking")]), _vm._v(" "), _c('p', [_vm._v("Continue without paying to get health and nutrition tracking. Pay to upgrade instantly at any time.")]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button paypalBtn free",
    attrs: {
      "type": "button",
      "label": "Proceed for free"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.continueFree()
      }
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45d266b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Payment/Payment.vue
// module id = 3702
// module chunks = 1